/**
 * EmailField - Specialized email input
 *
 * Pre-configured with Mail icon, email type, and appropriate defaults.
 */

import { Mail } from 'lucide-react';
import { TextField, type TextFieldProps } from './TextField';

export type EmailFieldProps = Omit<TextFieldProps, 'type' | 'icon' | 'autoComplete'> & {
  /** Override the default icon */
  icon?: TextFieldProps['icon'];
};

export function EmailField({
  icon = Mail,
  placeholder = 'email@example.com',
  ...props
}: EmailFieldProps) {
  return (
    <TextField
      {...props}
      type="email"
      icon={icon}
      placeholder={placeholder}
      autoComplete="email"
    />
  );
}
